(function($) {

	'use strict';

	var init = function() {
		var searchBtn = $('.js-toggle-search-popup');

		searchBtn.on('click', toggleSearchPopup);
	};

	var toggleSearchPopup = function (e) {
		
		var popup = $('#popup-search');
		popup.toggleClass('active');
		
		if(popup.hasClass('active')) {
			popup.find('form input[name="s"]').focus().select();
		}
		
	};

	$(document).ready(function() {
		init();
	});

})(jQuery);
